module.exports = __webpack_public_path__ + "fonts/Berlin.97874592.ttf";